// extracted by mini-css-extract-plugin
module.exports = {"forgotPassword":"auth_forgotPassword__lZN_y","actionItem":"auth_actionItem__IrqqD","link":"auth_link__qomjU","illustration":"auth_illustration__L_8iA"};